import { isEmpty, some } from 'lodash';
import userRoles from '@adjust/dashboard-core/lib/constants/userRoles';

function permissions() {
  'ngInject';
  return {
    restrict: 'E',
    scope: {},
    template: require('./permissions.html'),
    controller: 'PermissionsController',
    controllerAs: 'vm',
    bindToController: {
      showAppAccess: '=',
      features: '=',
      user: '=',
    },
  };
}

function PermissionsController($scope) {
  'ngInject';
  var vm = this;

  vm.goToAppAccess = goToAppAccess;
  vm.roles = userRoles;
  vm.hasFeatures = false;

  $scope.$watch('vm.features', _handleFeaturesChange, true);

  function goToAppAccess() {
    vm.showAppAccess = true;
  }

  function _handleFeaturesChange(newVal) {
    if (isEmpty(newVal)) {
      return (vm.hasFeatures = false);
    }

    vm.hasFeatures = some(newVal, 'available');
  }
}

export { PermissionsController, permissions };
